module.exports = __webpack_public_path__ + "static/linkbox-share-68785ddf0bbb90976b74a76daf67554a.png";